import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import {
	EditableManualReceiveLineItemRow,
	ReadonlyManualReceiveLineItemRow
} from "./ManualReceiveLineItemRow";
import { useStyles } from "./Invoice.styles";
import {ManualReceiveLineItemTableProps} from "./types";

export const EditableManualReceiveLineItemTable : React.FC<ManualReceiveLineItemTableProps<true>> = (props) => {
	return <ManualReceiveLineItemTable {...props} isEditable={true} />;
}

export const ReadonlyManualReceiveLineItemTable : React.FC<ManualReceiveLineItemTableProps> = (props) => {
	return <ManualReceiveLineItemTable {...props} isEditable={false} />;
}

const ManualReceiveLineItemTable: React.FC<ManualReceiveLineItemTableProps & { isEditable: boolean }> = (props) => {
	const {
		lineItems,
		isHardwareView,
		isLocationBayEditable,
		showDetailsOnly,
		showOverReceive,
		onLocationNameChange,
		priorityStock,
		isArrivalsFeatureEnabled,
		isPriorityStockEnabled,
	} = props;
	const classes = useStyles();

	function isRowEditable(
		props: ManualReceiveLineItemTableProps<boolean> & { isEditable: boolean }
	): props is ManualReceiveLineItemTableProps<true> & { isEditable: boolean } {
		return props.isEditable;
	}

	return (
		<TableContainer component={Paper}>
			<Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
				<TableHead>
					<TableRow>
						<TableCell className={classes.styledTableCell} style={{ width: '40px' }} />
						<TableCell className={classes.styledTableCell}>SKU</TableCell>
						<TableCell align="center" className={classes.styledTableCell}>
							Ordered
						</TableCell>
						<TableCell align="center" className={classes.styledTableCell}>
							Received
						</TableCell>
						{showDetailsOnly && (
							<TableCell align="center" className={classes.styledTableCell}>
								Remainder
							</TableCell>
						)}
					</TableRow>
				</TableHead>
				<TableBody>
					{lineItems?.map((row) => {
						const priorityStockItem = priorityStock?.find((ps) => ps.sku === row.sku);
						return isRowEditable(props)
							? (
								<EditableManualReceiveLineItemRow
									key={row.sku}
									lineItem={row}
									isHardwareView={isHardwareView}
									isLocationBayEditable={isLocationBayEditable}
									onReceivedQuantityChange={props.onReceivedQuantityChange}
									onCostChange={props.onCostChange}
									showDetailsOnly={showDetailsOnly}
									showOverReceive={showOverReceive}
									taxRate={row.taxPercentage / 100}
									onLocationNameChange={onLocationNameChange}
									priorityFlag={priorityStockItem?.flag ?? ""}
									priorityReason={priorityStockItem?.reason ?? ""}
									isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
									isPriorityStockEnabled={isPriorityStockEnabled}
								/>
							) : (
								<ReadonlyManualReceiveLineItemRow
									key={row.sku}
									lineItem={row}
									isHardwareView={isHardwareView}
									isLocationBayEditable={isLocationBayEditable}
									showDetailsOnly={showDetailsOnly}
									showOverReceive={showOverReceive}
									taxRate={row.taxPercentage / 100}
									onLocationNameChange={onLocationNameChange}
									priorityFlag={priorityStockItem?.flag ?? ""}
									priorityReason={priorityStockItem?.reason ?? ""}
									isArrivalsFeatureEnabled={isArrivalsFeatureEnabled}
									isPriorityStockEnabled={isPriorityStockEnabled}
								/>
							)
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export const MemorizedEditableManualReceiveLineItemTable = React.memo(EditableManualReceiveLineItemTable);
export const MemorizedReadonlyManualReceiveLineItemTable = React.memo(ReadonlyManualReceiveLineItemTable);
